import Country from '../dto/Country';
import Error from '../model/Error';
import axios from 'axios';

export default class CountriesRepository {
    static findAll() {
        return new Promise((resolve, reject) => {
            axios
                .get('/countries')
                .then((response) => resolve(response.data.data.map((data) => Country.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
